import { ThumbnailState } from './types';

export const initialThumbnailState: ThumbnailState = {
  show: false,
  imageUrl: '',
};
